import { render, staticRenderFns } from "./ClinicAcupointStat.vue?vue&type=template&id=5ee9d566&scoped=true"
import script from "./ClinicAcupointStat.vue?vue&type=script&lang=js"
export * from "./ClinicAcupointStat.vue?vue&type=script&lang=js"
import style0 from "./ClinicAcupointStat.vue?vue&type=style&index=0&id=5ee9d566&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee9d566",
  null
  
)

export default component.exports